import { formattedDateRange } from "@helpers"
import { ArrowRightCircleIcon, Square3Stack3DIcon } from "@heroicons/react/24/outline"
import { Button } from "@heroui/react"
import { isEmpty } from "lodash"
import PropTypes from 'prop-types'

const DataTableSessionHeader = ({ handleShowSessionsSidebar, session, showChangeSessionButton }) => (
  <div className="flex items-center justify-between w-full">
    <div className="flex gap-2">
      <Square3Stack3DIcon className={`${showChangeSessionButton ? 'w-16 h-16' : 'h-8 w-8'}`} />

      <div>
        {!isEmpty(session) ? (
          <h1 className="text-lg font-semibold leading-8">
            {session.title}
            {!showChangeSessionButton && (
              <span className="ml-2 text-base">
                ({formattedDateRange(session?.starts_at, session?.ends_at)})
              </span>
            )}
          </h1>
        ) : (
          <span>Loading...</span>
        )}
        
        { showChangeSessionButton && (
          <div className="flex items-center gap-2">
            <h2 className="text-base">
              {formattedDateRange(session?.starts_at, session?.ends_at)}
            </h2>
          </div>
        )}
      </div>
    </div>
    
    {showChangeSessionButton && (
      <Button 
        className="font-semibold text-white bg-green-500 hover:bg-green-600" 
        onPress={() => handleShowSessionsSidebar()} 
        endContent={<ArrowRightCircleIcon className="w-8 h-8" />}
      >
        Switch Session
      </Button>
    )}
  </div>
)

DataTableSessionHeader.propTypes = {
  handleShowSessionsSidebar: PropTypes.func.isRequired,
  session: PropTypes.object,
  showChangeSessionButton: PropTypes.bool.isRequired,
}

export default DataTableSessionHeader